import React, { ReactNode, createContext, useState, useCallback, useContext } from 'react';

interface DrawerPasswordContextData {
  openDrawerPassword: boolean;
  setOpenDrawerPassword: React.Dispatch<React.SetStateAction<boolean>>;
  onDrawerMobile: () => void;
  onClose: () => void;
}

type ProviderProps = {
  children: ReactNode;
};

const DrawerPasswordContext = createContext({} as DrawerPasswordContextData);

function DrawerPasswordProvider({ children }: ProviderProps) {
  const [openDrawerPassword, setOpenDrawerPassword] = useState<boolean>(false);

  const onClose = useCallback(() => {
    setOpenDrawerPassword(false);
  }, [openDrawerPassword]);

  const onDrawerMobile = useCallback(() => {
    console.log('aqui');
    setOpenDrawerPassword(true);
  }, [openDrawerPassword]);

  return (
    <DrawerPasswordContext.Provider
      value={{
        openDrawerPassword,
        setOpenDrawerPassword,
        onClose,
        onDrawerMobile,
      }}
    >
      {children}
    </DrawerPasswordContext.Provider>
  );
}

function useDrawerPassword(): DrawerPasswordContextData {
  const context = useContext(DrawerPasswordContext);

  if (!context) throw new Error('useDrawerPassword must be used within an DrawerPasswordProvider');

  return context;
}

export { DrawerPasswordProvider, useDrawerPassword };
